
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"36","height":"36","rx":"18","fill":"#F4F4F8"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M18 27v0a9 9 0 01-9-9v0a9 9 0 019-9v0a9 9 0 019 9v0a9 9 0 01-9 9z","stroke":"#6C7684","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M18 19.249v-.25c0-.817.505-1.26 1.011-1.6.494-.333.989-.767.989-1.567a2 2 0 10-4 0M17.999 22a.25.25 0 10.002.5A.25.25 0 0018 22","stroke":"#6C7684","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    